import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import * as LocationCardActions from '../actions';
import { FieldType } from '../models/field-models';
import { findFieldById } from '../configs/base-utils';
import { EchoLocationCardState } from '../configs/echo/models';
import { EchoInfoFieldIds, EchoSectionIds } from '../configs/echo/base-config-models';

export const echoReducer = createReducer(
    initialState as EchoLocationCardState,

    on(LocationCardActions.setEchoSiltValue, (state, { value }) => {
        const formState = { ...state.formState };
        const echoInfo = formState.config.sections.find((section) => section.id === EchoSectionIds.EchoInfo);

        if (!echoInfo) {
            console.error(`Echo section not found`);
            return state;
        }

        const siltField = findFieldById(formState, EchoInfoFieldIds.Silt, FieldType.Number);

        if (siltField && value) {
            siltField.value = value ?? 0;

            return { ...state, formState };
        }

        return state;
    }),
);
